import { gql, MutationTuple, useMutation } from '@apollo/client';

export const SAVE_PROFICIENCY_LEVEL = gql`
  mutation SaveProficiencyLevel(
    $skillId: NonEmptyString!
    $studentId: NonEmptyString!
    $currentProficiencyLevel: Int!
    $shouldReset: Boolean!
  ) {
    saveProficiencyLevel(
      skillId: $skillId
      studentId: $studentId
      currentProficiencyLevel: $currentProficiencyLevel
      shouldReset: $shouldReset
    ) {
      operationResult
    }
  }
`;

export interface ISaveProficiencyLevelParams {
  skillId: string;
  studentId: string;
  currentProficiencyLevel: number;
  shouldReset: boolean;
}

export interface ISaveProficiencyLevelResponse {
  saveProficiencyLevel: {
    operationResult: boolean;
  };
}

export const useMutationSaveProficiencyLevel = (): MutationTuple<
  ISaveProficiencyLevelResponse,
  ISaveProficiencyLevelParams
> => useMutation<ISaveProficiencyLevelResponse, ISaveProficiencyLevelParams>(SAVE_PROFICIENCY_LEVEL);
